import { Paper, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import videoUploadCancel from "../../../../assets/images/upload/uploadCancel.svg";
import "./videoSavedSuccessfully.scss";
import { PERSON_DASHBOARD } from "../../../../routes/routerPath";
import { searchParams, handleParams } from "../../../../utlis/helpers";
import { pageLocale } from "../../../../utlis/locale";
import { userInfoFetch } from "../../../../utlis/commonFunction";

const VideoCancel = ({ styleChange }) => {
  const moduleInfo = JSON.parse(sessionStorage.getItem("fromUpload") || "");
  const { cancel_upload, done } = pageLocale("videoUpload");
  const navigate = useNavigate();
  const cancelHandler = () => {
    const seniorId = userInfoFetch()?.id;
    if (seniorId) {
      navigate(PERSON_DASHBOARD + handleParams("seniorId", seniorId));
    } else {
      navigate(PERSON_DASHBOARD + `${searchParams}`);
    }
  };
  return (
    <div className="video-saved-success-main-wrapper">
      {!styleChange && (
        <Typography className="title">{moduleInfo?.moduleName}</Typography>
      )}
      <Paper elevation={3} className={`video-saved-success-wrapper`}>
        <img
          src={videoUploadCancel}
          alt="filesave"
          className="video-save-img"
        />
        <Typography className="saved-text">{cancel_upload}</Typography>
        <button onClick={() => cancelHandler()} className="common-btn">
          {done}
        </button>
      </Paper>
    </div>
  );
};

export default VideoCancel;
